// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Traffic Config API
 * traffic-config-api manages traffic configuration for the Aura platform.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface TrafficconfigAwsProperties
 */
export interface TrafficconfigAwsProperties {
  /**
   *
   * @type {Array<string>}
   * @memberof TrafficconfigAwsProperties
   */
  endpointIds?: Array<string>;
}

/**
 * Check if a given object implements the TrafficconfigAwsProperties interface.
 */
export function instanceOfTrafficconfigAwsProperties(
  value: object,
): value is TrafficconfigAwsProperties {
  return true;
}

export function TrafficconfigAwsPropertiesFromJSON(
  json: any,
): TrafficconfigAwsProperties {
  return TrafficconfigAwsPropertiesFromJSONTyped(json, false);
}

export function TrafficconfigAwsPropertiesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TrafficconfigAwsProperties {
  if (json == null) {
    return json;
  }
  return {
    endpointIds:
      json['endpoint_ids'] == null ? undefined : json['endpoint_ids'],
  };
}

export function TrafficconfigAwsPropertiesToJSON(
  json: any,
): TrafficconfigAwsProperties {
  return TrafficconfigAwsPropertiesToJSONTyped(json, false);
}

export function TrafficconfigAwsPropertiesToJSONTyped(
  value?: TrafficconfigAwsProperties | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    endpoint_ids: value['endpointIds'],
  };
}
